import { render, staticRenderFns } from "./users-page.vue?vue&type=template&id=33528f08&scoped=true&"
import script from "./users-page.vue?vue&type=script&lang=js&"
export * from "./users-page.vue?vue&type=script&lang=js&"
import style0 from "./users-page.vue?vue&type=style&index=0&id=33528f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33528f08",
  null
  
)

export default component.exports